import {
    AssistantListApiV1AssistantGetQueryParams,
    useAssistantListApiV1AssistantGetInfinite,
} from '../gen/base'

const DEFAULT_LIMIT = 50

export const useInfiniteAssistantListQuery = (
    params: AssistantListApiV1AssistantGetQueryParams,
) => {
    const limit = params.limit ?? DEFAULT_LIMIT

    return useAssistantListApiV1AssistantGetInfinite(
        { ...params, limit },
        {},
        {
            query: {
                getNextPageParam: (lastPage, allPages) =>
                    lastPage.offset + limit <= lastPage.total_count
                        ? allPages.length * limit
                        : null,
                initialPageParam: 0,
            },
        },
    )
}
